// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3hCHn","footer":"ChangeClinic_footer__8qt0r"};